import React from 'react';
import { UserCircle, LegoSmiley } from '@phosphor-icons/react';

import useAuthUserStore from '../../../../hooks/useAuthUserStore';

const ProfileIcon = () => {
  const { user, adminMode } = useAuthUserStore();

  const getInitials = () => {
    return (
      (user.firstName ? user.firstName[0].toUpperCase() : '') +
      (user.lastName ? user.lastName[0].toUpperCase() : '')
    );
  };

  if (!user.firstName && !user.lastName)
    return (
      <div className="w-12 h-12 flex items-center justify-center hover:opacity-80">
        <div className="absolute w-9 h-9 bg-cc-purple-700 rounded-full z-0" />
        <UserCircle
          weight="fill"
          color="white"
          className="w-full h-full z-[1]"
        />
      </div>
    );

  return (
    <div className="w-8 aspect-square flex items-center justify-center bg-cc-purple-700 text-white font-medium rounded-full hover:opacity-80">
      {adminMode ? <LegoSmiley weight="fill" size="1.25rem" /> : getInitials()}
    </div>
  );
};

export default ProfileIcon;
